module.exports = __webpack_public_path__ + "img/play.987a519c.svg";